<div class="track-my-location-container" style="background-color: #fff;">
  <div class="track-my-location">

    <div class="header col-12 md:col-12 lg:col-12 sm:col-12">
      <div class="col-6 md:col-12 lg:col-6 sm:col-12 contact-info">
        <a href="" target="_blank">
          <img width="200" src="/assets/images/temp/MI_black_logo.png">
        </a>
      </div>
    </div>
    <div class=" col-nopad col-12 md:col-12 lg:col-12">
      <div class="seperator"></div>
    </div>

    <div class="gap-12 md:col-12 lg:col-12" style="padding: 20px;">
      <h1>Terms and Conditions</h1>
      <p><strong>Last Updated: February 19, 2026</strong></p>

      <h2>1. Acceptance of Terms</h2>
      <p>By accessing and using CityRide's transportation services, mobile application, or website, you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our services.</p>

      <h2>2. Description of Services</h2>
      <p>CityRide provides on-demand transportation services, including taxi rides, car rentals, and chauffeur services. Our services connect passengers with independent drivers and vehicle operators.</p>

      <h2>3. User Eligibility</h2>
      <p>To use our services, you must:</p>
      <ul>
        <li>Be at least 18 years of age</li>
        <li>Have the legal capacity to enter into binding agreements</li>
        <li>Provide accurate and complete information when creating an account</li>
        <li>Maintain the security of your account credentials</li>
      </ul>

      <h2>4. Account Registration</h2>
      <p>You are responsible for:</p>
      <ul>
        <li>Maintaining the confidentiality of your account password</li>
        <li>All activities that occur under your account</li>
        <li>Notifying us immediately of any unauthorized use</li>
        <li>Ensuring your account information is accurate and up-to-date</li>
      </ul>

      <h2>5. Booking and Payment</h2>
      <h3>5.1 Booking Process</h3>
      <p>When you book a ride through our platform:</p>
      <ul>
        <li>You agree to pay the fare displayed at the time of booking</li>
        <li>Fares may vary based on distance, time, demand, and route</li>
        <li>Additional charges may apply for tolls, parking, or waiting time</li>
        <li>You must be present at the pickup location at the scheduled time</li>
      </ul>

      <h3>5.2 Payment Terms</h3>
      <p>Payment terms include:</p>
      <ul>
        <li>Payment is due upon completion of the trip</li>
        <li>We accept credit cards, debit cards, and digital wallets</li>
        <li>All prices are in the local currency unless otherwise stated</li>
        <li>Refunds are subject to our refund policy</li>
      </ul>

      <h2>6. Cancellation Policy</h2>
      <p>Cancellation terms:</p>
      <ul>
        <li>You may cancel a booking before the driver arrives without penalty</li>
        <li>Cancellation fees may apply if canceled after driver arrival or during the trip</li>
        <li>Drivers may cancel bookings under certain circumstances</li>
        <li>Refunds for cancellations will be processed according to our refund policy</li>
      </ul>

      <h2>7. User Conduct</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use our services for any illegal or unauthorized purpose</li>
        <li>Violate any laws or regulations while using our services</li>
        <li>Interfere with or disrupt the services or servers</li>
        <li>Harass, abuse, or harm drivers or other users</li>
        <li>Attempt to gain unauthorized access to our systems</li>
        <li>Use automated systems to access our services without permission</li>
      </ul>

      <h2>8. Driver and Vehicle Standards</h2>
      <p>We strive to ensure:</p>
      <ul>
        <li>All drivers are licensed and qualified</li>
        <li>Vehicles meet safety and quality standards</li>
        <li>Drivers maintain professional conduct</li>
        <li>Vehicles are clean and well-maintained</li>
      </ul>
      <p>However, CityRide is not responsible for the actions or conduct of independent drivers.</p>

      <h2>9. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law:</p>
      <ul>
        <li>CityRide acts as an intermediary connecting passengers with drivers</li>
        <li>We are not liable for any accidents, injuries, or damages that occur during transportation</li>
        <li>Our liability is limited to the amount you paid for the specific trip</li>
        <li>We are not responsible for delays, cancellations, or service interruptions</li>
      </ul>

      <h2>10. Insurance</h2>
      <p>Drivers are required to maintain appropriate insurance coverage. CityRide maintains commercial liability insurance, but passengers are encouraged to have their own insurance coverage.</p>

      <h2>11. Intellectual Property</h2>
      <p>All content, trademarks, logos, and intellectual property on our platform are owned by CityRide or our licensors. You may not use, reproduce, or distribute any content without our written permission.</p>

      <h2>12. Privacy</h2>
      <p>Your use of our services is also governed by our Privacy Policy. Please review our Privacy Policy to understand how we collect, use, and protect your information.</p>

      <h2>13. Modifications to Services</h2>
      <p>We reserve the right to:</p>
      <ul>
        <li>Modify, suspend, or discontinue any aspect of our services</li>
        <li>Change pricing, features, or availability</li>
        <li>Update these Terms and Conditions at any time</li>
      </ul>
      <p>Continued use of our services after changes constitutes acceptance of the modified terms.</p>

      <h2>14. Termination</h2>
      <p>We may terminate or suspend your account and access to our services immediately, without prior notice, for any violation of these Terms and Conditions or for any other reason we deem necessary.</p>

      <h2>15. Dispute Resolution</h2>
      <p>Any disputes arising from these Terms and Conditions or your use of our services shall be resolved through:</p>
      <ul>
        <li>Good faith negotiation</li>
        <li>Mediation if negotiation fails</li>
        <li>Binding arbitration in accordance with applicable laws</li>
      </ul>

      <h2>16. Governing Law</h2>
      <p>These Terms and Conditions are governed by and construed in accordance with the laws of the jurisdiction in which CityRide operates, without regard to its conflict of law provisions.</p>

      <h2>17. Severability</h2>
      <p>If any provision of these Terms and Conditions is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.</p>

      <h2>18. Entire Agreement</h2>
      <p>These Terms and Conditions, together with our Privacy Policy, constitute the entire agreement between you and CityRide regarding the use of our services.</p>

      <h2>19. Contact Information</h2>
      <p>If you have any questions about these Terms and Conditions, please contact us:</p>
      <ul>
        <li>Email: support&#64;cityride.com</li>
        <li>Phone: +1 (555) 123-4567</li>
        <li>Address: 123 Transport Street, City, State 12345</li>
      </ul>

      <h2>20. Acknowledgment</h2>
      <p>By using CityRide's services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.</p>
    </div>
  </div>
</div>
